module.exports = __webpack_public_path__ + "img/thumb-2.5ce8ba38.jpg";